/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import template from "templates/layouts/sale_hub_layout";

export default baustein.register("sale-hub-layout", {
    template,

    defaultOptions: {
        gender: null,
        product_type: null,
        designer_slug: null
    },

    getInitialRenderContext() {
        return {
            sale_hub_layout: {}
        };
    }
});

